import { render, staticRenderFns } from "./FormPage2.vue?vue&type=template&id=19e12ed4&scoped=true&"
import script from "./FormPage2.vue?vue&type=script&lang=js&"
export * from "./FormPage2.vue?vue&type=script&lang=js&"
import style0 from "./FormPage2.vue?vue&type=style&index=0&id=19e12ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e12ed4",
  null
  
)

export default component.exports